import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';

import Header from '../Global/Header';

const Innernews = (props) => {

    const [state, setState] = useState({
        data: [], // data news
        loader: true, // loader status
    })

    useEffect(() => {


        base_url.get(`news/${props.match.params.id}`)
            .then(response => {
                console.log(response.data)
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="inner-news">
            <Header
                innerPage={true}
                title={'اخبار'} />
            <Loader
                active={state.loader} />
            <div className="web-view">
                {/* <iframe src={state.data.url} id="iFrame1" frameborder="0" height="300">
                </iframe> */}
                <div dangerouslySetInnerHTML={{ __html: state.data.page_source }}></div>
                <div className="list-tags">
                    {state.data.length == 0 ? null : state.data.tags.map(info =>
                        <span key={info.name}>{info.name}</span>
                    )}
                </div>
                {state.data.length == 0 ? null : state.data.comment_status ?
                    <Link
                        to={`/Comments/${props.match.params.id}`}
                        className="comment-fix" >
                        <i className="icon-comment"></i>
                    </Link>
                    : null
                }
            </div>
        </div>
    );
}

export default Innernews;